const Estatus = ({ inProgressCourses, terminatedCourses }: any) => {
  return <span>{terminatedCourses > 0 ? "Terminado" : "En proceso"}</span>;
};

export default Estatus;
